import { Box, styled } from "@mui/material";
import { IStyledBoardProps } from "./types";

const StyledBoard = styled(Box)<IStyledBoardProps>(({ theme }) => ({
    position: 'relative',
    boxSizing: "border-box",
    width: "100%",
    marginTop: theme.spacing(2)
}))

export { StyledBoard }